import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { VicnamesSearchService } from '@lassi/webapp-shared';

export const polygonSearchResolver: ResolveFn<string> = () => {
  const service = inject(VicnamesSearchService);

  const polygon = service.polygonSearch();

  if (!polygon) {
    return '';
  }
  console.log(JSON.stringify(polygon.toGeoJSON().geometry));
  return JSON.stringify(polygon.toGeoJSON().geometry);
};
